import script from "./EmailSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__